import {
  NgModule,
  ModuleWithProviders,
  SkipSelf,
  Optional,
} from '@angular/core';
import { PaymentAuxConfiguration, CONFIG_TOKEN } from './configuration';
import { HttpClient } from '@angular/common/http';

import { DataModulesManager } from '@backbase/foundation-ang/data-http';
@NgModule({
  imports: [],
  declarations: [],
  exports: [],
  providers: [],
})
export class PaymentAuxApiModule {
  public static forRoot(
    configurationFactory: () => PaymentAuxConfiguration
  ): ModuleWithProviders<PaymentAuxApiModule> {
    return {
      ngModule: PaymentAuxApiModule,
      providers: [
        { provide: PaymentAuxConfiguration, useFactory: configurationFactory },
      ],
    };
  }

  constructor(
    @Optional() @SkipSelf() parentModule: PaymentAuxApiModule,
    @Optional() http: HttpClient,
    @Optional() dataModulesManager: DataModulesManager | null,
    config: PaymentAuxConfiguration
  ) {
    if (parentModule) {
      throw new Error(
        'PaymentAuxApiModule is already loaded. Import in your base AppModule only.'
      );
    }
    if (!http) {
      throw new Error(
        'You need to import the HttpClientModule in your AppModule! \n' +
          'See also https://github.com/angular/angular/issues/20575'
      );
    }

    if (dataModulesManager) {
      dataModulesManager.setModuleConfig(CONFIG_TOKEN, {
        apiRoot: '',
        servicePath: config.basePath || '',
        headers: {},
      });
    }
  }
}
